module.exports = __webpack_public_path__ + "static/media/cake.82b37027.jpg";